/**
 * 处方表单相关工具函数 TODO 这里面的内容在 PrescriptionFormV2 中已经有了，后面删除掉
 */

import { IPrescriptionOptions } from '@/components/PrescriptionFormV2/types';
import { NO_DATA } from '@/utils/constants';
import { EPrescriptionType } from '@/utils/enums/goods';
import { abs, subtract, toNumber } from '@/utils/math';
import { hasTwoPd } from '@/utils/prescription';

/**
 * 处方表单是否展示灰色
 */
export const getADDData = (str: string | null | undefined, prescriptionType: EPrescriptionType) => {
  if (
    [EPrescriptionType.SINGLE_VISION, EPrescriptionType.SUNGLASSES_PRESCRIPTION].includes(
      prescriptionType,
    )
  ) {
    return NO_DATA;
  }
  return str == null || str === '' ? NO_DATA : str;
};

/**
 * 处方表单是否展示灰色
 */
export const showGrayTd = (
  prescription: IPrescriptionOptions,
  key: keyof IPrescriptionOptions,
  prescriptionType?: EPrescriptionType,
) => {
  switch (key) {
    case 'od_axis':
    case 'os_axis':
      return prescription[key] === 'None';
    case 'od_add':
    case 'os_add':
      return getADDData(prescription[key], prescriptionType) === NO_DATA;
    case 'od_pv':
    case 'os_pv':
    case 'od_pv_r':
    case 'os_pv_r':
    case 'od_bd':
    case 'os_bd':
    case 'od_bd_r':
    case 'os_bd_r':
      return !prescription[key];
    default:
      return false;
  }
};

export const sphDiff = (prescription: IPrescriptionOptions) => {
  let status = 0;
  let od_sph: number;
  let os_sph: number;
  if (prescription.od_sph === 'PL') {
    od_sph = 0;
  } else {
    od_sph = parseFloat(prescription.od_sph);
  }
  if (prescription.os_sph === 'PL') {
    os_sph = 0;
  } else {
    os_sph = parseFloat(prescription.os_sph);
  }
  // 0 正常
  if (isNaN(od_sph) || isNaN(os_sph)) {
    return 0;
  }

  if (od_sph < 0 !== os_sph < 0 && od_sph !== 0 && os_sph !== 0) {
    // OD、OS的SPH值一正一负。
    status = 1;
  } else if (Math.abs(od_sph - os_sph) >= 3) {
    // OD、OS的SPH值相差3。
    status = 2;
  } else {
    status = 0;
  }
  return status;
};
export const cylDiff = (prescription: IPrescriptionOptions) => {
  let status = 0;
  let od_cyl: number;
  let os_cyl: number;
  if (prescription.od_cyl === 'SPH/DS') {
    od_cyl = 0;
  } else {
    od_cyl = parseFloat(prescription.od_cyl);
  }
  if (prescription.os_cyl === 'SPH/DS') {
    os_cyl = 0;
  } else {
    os_cyl = parseFloat(prescription.os_cyl);
  }
  // 0 正常
  if (isNaN(od_cyl) || isNaN(os_cyl)) return 0;

  if (od_cyl < 0 !== os_cyl < 0 && od_cyl !== 0 && os_cyl !== 0) {
    // OD、OS的 cyl 值一正一负。
    status = 1;
  } else if (Math.abs(od_cyl - os_cyl) >= 3) {
    // OD、OS的 cyl 值相差3。
    status = 2;
  } else {
    status = 0;
  }
  return status;
};
export const moreThan5Diff = (prescription: IPrescriptionOptions) => {
  // 【ID1007806】配镜流程-填写处方单增加双PD差值过大提醒
  const innerMoreThan5Diff =
    hasTwoPd(prescription) && toNumber(abs(subtract(prescription.pd_l, prescription.pd_r))) >= 5;
  return innerMoreThan5Diff;
};

/**
 * 处方表单上下文接口
 */
// interface PrescriptionContext {
//   presType: string;
//   prescription: {
//     hasTwoPd: boolean;
//   };
//   doublePdMin: number;
//   doublePdMax: number;
//   usePd: {
//     min_pd: string | number;
//     max_pd: string | number;
//   };
// }

/**
 * 选项值接口
 */
// interface OptionValue {
//   value: string;
//   label: string;
// }

/**
 * 获取处方表单特定字段的选项
 * @param type 表单字段类型
 * @param context 处方表单上下文
 * @param presType 处方类型
 * @returns 字段对应的选项列表
 */
// export function getOptions(
//   type: string,
//   context: PrescriptionContext,
//   presType?: string,
// ): string[] | OptionValue[] {
//   const validPresType = presType || context.presType;
//   const isProgressive = validPresType === EPrescriptionType.PROGRESSIVE;
//   // 是否为处方太阳镜
//   const isSunglassesPres = validPresType === EPrescriptionType.SUNGLASSES_PRESCRIPTION;
//   let min = 0;
//   let max = 0;

//   switch (type) {
//     case 'od_sph':
//     case 'os_sph':
//       if (
//         validPresType === EPrescriptionType.SINGLE_VISION ||
//         validPresType === EPrescriptionType.READING_GLASSES
//       ) {
//         min = -20;
//         max = 10;
//       } else if (isProgressive) {
//         min = -18;
//         max = 10;
//       } else if (isSunglassesPres) {
//         // 【ID1007145】太阳镜处方的SPH、CYL可选值范围变更
//         min = -16;
//         max = 10;
//       } else {
//         min = -8;
//         max = 6;
//       }
//       return updateArray(
//         getToFix2NumArr(getEqualDiffArrWithSymbol(min, max, 0.25)),
//         '0.00',
//         'PL',
//         'right',
//       );
//     case 'od_cyl':
//     case 'os_cyl':
//       // 【ID1007145】太阳镜处方的SPH、CYL可选值范围变更
//       min = -6;
//       max = 6;
//       return updateArray(
//         getToFix2NumArr(getEqualDiffArrWithSymbol(min, max, 0.25)),
//         '0.00',
//         'SPH/DS',
//         'right',
//       );
//     case 'od_axis':
//     case 'os_axis':
//       return ['None'].concat(getEqualDiffArr(1, 180, 1));
//     case 'od_add':
//     case 'os_add':
//       min = isProgressive ? 0.5 : 0;
//       return getToFix2NumArr(getEqualDiffArrWithSymbol(min, 3.5, 0.25));
//     case 'pd':
//       if (context.prescription.hasTwoPd) {
//         min = context.doublePdMin;
//         max = context.doublePdMax;
//         return getToFix2NumArr(getEqualDiffArr(min, max, 0.5));
//       } else {
//         min = parseInt(String(context.usePd.min_pd || 54), 10);
//         max = parseInt(String(context.usePd.max_pd || 78), 10);
//         return getToFix2NumArr(getEqualDiffArr(min, max, 0.5));
//       }
//     case 'single_pd':
//       min = parseInt(String(context.usePd.min_pd || 54), 10);
//       max = parseInt(String(context.usePd.max_pd || 78), 10);
//       return getToFix2NumArr(getEqualDiffArr(min, max, 0.5));
//     case 'pd_l':
//     case 'pd_r':
//       min = context.doublePdMin;
//       max = context.doublePdMax;
//       return getToFix2NumArr(getEqualDiffArr(min, max, 0.5));
//     case 'od_pv':
//     case 'os_pv':
//     case 'od_pv_r':
//     case 'os_pv_r':
//       return getToFix2NumArr(getEqualDiffArr(0.5, 5, 0.25));
//     case 'os_bd_r':
//     case 'od_bd_r':
//       return [
//         { value: 'Up', label: 'Up' },
//         { value: 'Down', label: 'Down' },
//       ];
//     case 'od_bd':
//     case 'os_bd':
//       return [
//         { value: 'In', label: 'In' },
//         { value: 'Out', label: 'Out' },
//       ];
//     default:
//       return [];
//   }
// }

/**
 * 获取等差数组
 * @param start 起始值
 * @param end 结束值
 * @param difference 差值
 * @returns 等差数组
 */
// export function getEqualDiffArr(start: number, end: number, difference: number): string[] {
//   if (((end - start) / difference) % 1 > 0) {
//     return [];
//   }
//   return new Array((end - start) / difference + 1).fill(0).map((item, index) => {
//     return String(start + difference * index);
//   });
// }

/**
 * 获取带符号的等差数组
 * @param start 起始值
 * @param end 结束值
 * @param difference 差值
 * @returns 带符号的等差数组
 */
// export function getEqualDiffArrWithSymbol(
//   start: number,
//   end: number,
//   difference: number,
// ): Array<string | number> {
//   return getEqualDiffArr(start, end, difference).map((item) => {
//     const num = parseFloat(item);
//     return num === 0 ? '0' : (num > 0 ? '+' : '') + num;
//   });
// }

/**
 * 数字小数点后补齐2位
 * @param arr 数字数组
 * @returns 格式化后的数组
 */
// export function getToFix2NumArr(arr: Array<string | number>): string[] {
//   return arr.map((item) => {
//     const a = String(item).split('.');
//     a.length === 1 ? a.push('00') : a[1].length === 1 && (a[1] += '0');
//     return a.join('.');
//   });
// }

/**
 * 数组加值
 * @param arr 原数组
 * @param target 目标值
 * @param value 要添加的值
 * @param place 位置（'right'表示在目标值右侧添加）
 * @returns 更新后的数组
 */
// export function updateArray(arr: string[], target: string, value: string, place: string): string[] {
//   const newArr = [...arr];
//   newArr.splice(newArr.indexOf(target) + (place === 'right' ? 1 : 0), 0, value);
//   return newArr;
// }

/**
 * 返回空处方
 * @returns 空处方对象
 */
// export function getEmptyPrescription(): Record<string, any> {
//   return {
//     od_sph: '0.00',
//     os_sph: '0.00',
//     od_cyl: '0.00',
//     os_cyl: '0.00',
//     od_axis: 'None',
//     os_axis: 'None',
//     od_add: '0.00',
//     os_add: '0.00',
//     // 两组PD
//     hasTwoPd: false,
//     pd: '',
//     pd_l: '',
//     pd_r: '',
//     // 是否具有斜视数据
//     hasStrabismus: false,
//     od_pv: '0.00',
//     od_bd: '',
//     os_pv: '0.00',
//     os_bd: '',
//     od_pv_r: '0.00',
//     od_bd_r: '',
//     os_pv_r: '0.00',
//     os_bd_r: '',
//     saveMyPres: false,
//     name: '',
//   };
// }
